import SchemasContainer from './containers/SchemasContainer';

const SchemasView = () => <SchemasContainer />;

export default SchemasView;
